module.exports = __webpack_public_path__ + "static/media/mail.5d81c30f.svg";